#import "../fragments/competitors-lead-fragment.graphql"

mutation AddCompetitorToLead($input: LeadCompetitorAddInput!) {
    leadCompetitorAdd(input: $input) {
        lead {
            ...CompetitorsLeadFragment
        }
    }
}
